var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSlideIzq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D41245",
    fillRule: "nonzero",
    d: "M45 0C20.149 0 0 20.149 0 45s20.149 45 45 45 45-20.149 45-45S69.851 0 45 0zm-8.934 46.324l16.875 16.875-5.726 5.625-22.399-22.5 22.399-22.5 5.726 5.625-16.875 16.875z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSlideIzq);
export default __webpack_public_path__ + "static/media/arrow-slide-izq.34e9637ee3f83995daa03c864b35705d.svg";
export { ForwardRef as ReactComponent };